// extracted by mini-css-extract-plugin
export var completionBody = "_ho-2";
export var completionCard = "_ho-0";
export var completionFooter = "_ho-3";
export var completionTitle = "_ho-1";